import { render, staticRenderFns } from "./MelhorPlano.vue?vue&type=template&id=5b17b887&scoped=true"
import script from "./MelhorPlano.vue?vue&type=script&lang=js"
export * from "./MelhorPlano.vue?vue&type=script&lang=js"
import style0 from "./MelhorPlano.vue?vue&type=style&index=0&id=5b17b887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b17b887",
  null
  
)

export default component.exports